export default __webpack_public_path__ + "static/media/avatar-s-14.e500ce80.jpg";